import React, { Component } from 'react';
import { connect } from 'react-redux';
import './NewProject.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import CheckBox from 'components/shared/checkbox/CheckBox';
import { usersUtil, TYPES } from 'services/utils/users-util';
import { getCurrentUser } from 'selectors/authentication';
import {
  getGeneralContractors,
  getCurrentPage,
  getProjectForm,
} from 'components/admin/projects/creation/store/selectors';
import {
  loadGeneralContractorsRequest,
  setGeneralContractors,
  setProjectFormValue,
  nextStage,
} from 'components/admin/projects/creation/store/actions';

class GeneralContractorSelection extends Component {
  componentDidMount() {
    if (usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR)) {
      this.props.dispatch(nextStage());
    } else {
      this.props.dispatch(loadGeneralContractorsRequest(1));
    }
  }

  handleProjectFormChange = (attribute, value) => {
    this.props.dispatch(setProjectFormValue(attribute, value));
  };

  handleContinue = () => {
    this.props.dispatch(nextStage());
  };

  handlePageChange = (newPage) => {
    this.props.dispatch(setGeneralContractors([]));
    this.props.dispatch(loadGeneralContractorsRequest(newPage));
  };

  render() {
    return (
      <div>
        {this.props.generalContractors !== null && (
          <div>
            <h3 className="selection-title">
              Which general contractor is the Project for?
            </h3>

            <div className="selection-table-container">
              <SimpleTable
                headers={['', 'COMPANY NAME', 'CONTACT']}
                rows={this.mapGeneralContractors(
                  this.props.generalContractors.data
                )}
                emptyMessage="No General Contractors"
              />
            </div>

            <div className="pagination-container">
              <SimplePagination
                currentPage={this.props.currentPage}
                pageSize={this.props.generalContractors.pageSize}
                total={this.props.generalContractors.total}
                onPageChange={this.handlePageChange}
              />
            </div>

            <input
              className={`btn button button-continue ${
                this.canContinue() ? 'button-orange' : 'button-disabled'
              }`}
              type="button"
              value="Continue"
              onClick={this.handleContinue}
              disabled={!this.canContinue()}
            />
          </div>
        )}
      </div>
    );
  }

  mapGeneralContractors = (generalContractors) => {
    return generalContractors.map((generalContractor) => {
      return [
        <CheckBox
          id={generalContractor.id}
          checked={
            generalContractor.id === this.props.projectForm.generalContractorId
          }
          shape={'round'}
          size={'medium'}
          onChange={this.handleProjectFormChange.bind(
            this,
            'generalContractorId'
          )}
        />,
        <span className="h4">{generalContractor.name}</span>,
        `${generalContractor.contact.first_name} ${generalContractor.contact.last_name}`,
      ];
    });
  };

  canContinue = () => {
    return !!this.props.projectForm.generalContractorId;
  };
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    generalContractors: getGeneralContractors(state),
    currentPage: getCurrentPage(state),
    projectForm: getProjectForm(state),
  };
})(GeneralContractorSelection);



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/GeneralContractorSelection.js